/**
 * @file fraud.js
 * @description 欺诈通知模块路由配置
 * @module router/config/fraud
 * @Business 欺诈相关业务的路由定义，包括欺诈通知查询等功能
 */

export default [
  {
    path: 'risk/fraud-notification',
    name: 'Fraud Notification',
    component: () => import('@/views/risk/fraud-notification/index.vue'),
    meta: {
      icon: 'icon-qizhayufengkong',
      resourceCode: 'risk:fraud-notification:list',
      name: 'message.fraudNotification.title',
    },
  },
];
